const data = {
  id: 1,
  title: 'Put the numbers in ascending order',
  subTitle: 'Sắp xếp các số theo thứ tự từ bé đến lớn',
  audioUrl: '',
  imageUrl: '',
  question: 'one two three',
  answer: 'one two three',
  settings: {
    question: {
      shuffedType: 'word',
      // shuffedType: 'character',
    },
  },
};

export default data;
